(function () {
    'use strict';

    angular
        .module('EventListApp')
        .filter('filterMultiple', filterMultiple);

    function filterMultiple() {
        function isContainValue(value, searchStr) {
            if (!searchStr || searchStr == '0' || !value)
                return true;

            if (isNaN(value) && !angular.isArray(value)) {
                return value.toLowerCase().indexOf(searchStr.toLowerCase()) > -1;
            }
            else {
                searchStr = parseInt(searchStr);
                if (angular.isArray(value))
                    return value.indexOf(searchStr) > -1;
                else
                    return value == searchStr;
            }
        }

        function findByProp(o, prop) {
            if (o == null)
                return false;

            if (o.hasOwnProperty(prop)) {
                return o[prop];
            }

            var result, p;
            for (p in o) {
                if (o.hasOwnProperty(p) && typeof o[p] === 'object') {
                    result = findByProp(o[p], prop);
                    if (result) {
                        return result;
                    }
                }
            }
            return result;
        }

        return function (items, keyObj) {
            var filtered = [];
            if (keyObj) {
                angular.forEach(items, function (item, idx) {
                    var isValid = true;
                    angular.forEach(keyObj, function (value, key) {
                        if (!isValid)
                            return false;

                        if (!Array.isArray(value)) {
                            if (item.hasOwnProperty(key)) {
                                isValid = isContainValue(item[key], value);
                            }
                            else {
                                let val = findByProp(object, key);
                                if (val)
                                    isValid = isContainValue(val, value);
                            }
                        }
                        else {
                            for (var i = 0; i < value.length; i++) {
                                isValid = isContainValue(item[key], value[i]);
                                if (!isValid)
                                    break;
                            }
                        }

                    });
                    if (isValid)
                        filtered.push(item);
                });
            }
            return filtered;
        }
    }

})();